import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import {
  saveServiceProviders,
  sendEmail,
  sendVerificationMail,
} from "../../api";
import { FORM_TEXTS } from "../../constants";
import { LeftBanner } from "../../layout/LeftBanner";
import { NavBar } from "../../layout/NavBar";
import { setNotification } from "../../redux/notificationSlice";
import { ContactDetails } from "../forms/ContactDetails";
import { FormButtons } from "../forms/FormButtons";
import { VendorDetails } from "../forms/VendorDetails";
import { ServiceOfferingTags } from "./ServiceOfferingTags";

export const CreateVendor = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [tags, setTags] = useState([]);
  const [createTagError, setCreateTagError] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const submitForm = async (data) => {
    data.country = data.country?.value ?? "";
    delete data.servicesProvided;
    delete data.serviceCountries;
    if (tags.length === 0) {
      setCreateTagError(true);
      return;
    } else {
      setCreateTagError(false);
    }
    data.tags = tags;
    const requestData = {
      operation: "createServiceProvider",
      request: data,
    };
    const saveResp = await saveServiceProviders(requestData);
    if (saveResp?.responseCode === 200) {
      setIsSubmitted(true);
      dispatch(
        setNotification({
          type: "success",
          show: true,
          message: "Success! service provider added successfully",
        })
      );
      const ServiceProviderData = {
        operation: "createEmailToken",
        request: {
          requestId: saveResp.responseData?.data,
          email: data?.primaryEmail,
          type: "primary",
        },
      };
      const resp = await sendVerificationMail(ServiceProviderData);
      const emailBody = `<div className="bg-gray-100 p-8 font-sans">
      <div className="max-w-xl mx-auto bg-white rounded-lg shadow-md p-8">
        <p className="mb-4">Dear ${data.primaryName},</p>
        <p className="mb-4">
          The service provider details with Request ID # ${saveResp.responseData?.data} has been created. Please remember the Request ID, as it will be required to update the data in the future.
          </br>Please click on the link below to verify your email address. This will be valid till 30 minutes.
          <p className="mb-2">
            ${process.env.REACT_APP_BASE_URL}/verify-email/${resp.responseData?.id}/primary/${resp.responseData?.token},
          </p>
          <p className="mb-4">Please do not reply to this email as this is an automated email.</p>
        </p>
        <p className="mb-4">
          Thanks!</br>
          MSD GCTO Service Portal
        </p>
      </div>
    </div>`;
      const createEmailSubject =
        "[MSD GCTO Service Provider Portal] Service Provider Created";
      sendEmail(createEmailSubject, emailBody, [data.primaryEmail]);
    } else if (saveResp?.responseCode === 400) {
      dispatch(
        setNotification({
          type: "error",
          show: true,
          message:
            "There has been an error occurred. Please contact the support for further assistance.",
        })
      );
    } else {
      dispatch(
        setNotification({
          type: "error",
          show: true,
          message:
            "There is some issue adding service provider. Please try again",
        })
      );
    }
  };

  useEffect(() => {
    if (isSubmitted) {
      const timer = setTimeout(() => {
        navigate("/");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isSubmitted, navigate]);

  return (
    <>
      <NavBar />
      <div className="flex mr-4">
        <div className="flex-none w-64">
          <LeftBanner />
        </div>
        <div className="flex-1 pr-24">
          <div className="w-full">
            <h3 className="font-normal text-2xl text-teal-600">
              {FORM_TEXTS.CREATE_RECORD}
            </h3>
            <form className="my-5" onSubmit={handleSubmit(submitForm)}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 my-5">
                <VendorDetails
                  control={control}
                  register={register}
                  errors={errors}
                />
                <ServiceOfferingTags tags={tags} setTags={setTags} state={""} />
                <div className="grid grid-cols-1 px-2 rounded-md">
                  {tags.length === 0 && createTagError && (
                    <div className="inline-block gap-2 mt-1">
                      <span className="text-red-500 text-sm">
                        Please create atleast one tag.
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <ContactDetails register={register} errors={errors} />
              <FormButtons navigate={navigate} />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
